import { render, staticRenderFns } from "./SendResetPasswordMail.vue?vue&type=template&id=07c0f706&scoped=true&"
import script from "./SendResetPasswordMail.vue?vue&type=script&lang=js&"
export * from "./SendResetPasswordMail.vue?vue&type=script&lang=js&"
import style0 from "./SendResetPasswordMail.vue?vue&type=style&index=0&id=07c0f706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0f706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VForm,VImg,VRow,VTextField})
